import {
  computed,
  inject,
} from '@vue/composition-api';
import { lowerCase } from 'lodash';

export default (props) => {
  const helpers = inject('helpers');
  const constants = inject('constants');

  const questionData = computed(() => props.stepData || props.form.home);

  const getTextByValue = (list, value) => {
    const item = list.find(el => el.value === value);
    return item.text;
  };

  const selectedWallsView = computed(() => {
    const list = [...helpers.createOptions({ source: constants.HOME_PROPERTY_WALLS_MADE })];

    return getTextByValue(list, questionData.value.propertyWallsMade);
  });
  const propertyNearestRiverItems = computed(() => {
    return helpers.createOptions({ source: constants.HOME_PROPERTY_NEAREST_RIVER, asNumbers: true });
  });
  const propertyListedItems = computed(() => {
    return helpers.createOptions({ source: constants.HOME_PROPERTY_LISTED });
  });

  const wallsMade = computed(() => {
    if (helpers.isNull(questionData.value.propertyWallsMade) || !questionData.value.propertyWallsMade) {
      return 'Please, select a value';
    }

    return `Your exterior walls are made of <span class="notice">${selectedWallsView.value}</span>`;
  });
  const landslipHeave = computed(() => {
    if (helpers.isNull(questionData.value.propertyLandslipHeave)) {
      return 'Please, select a value';
    }

    const msg = 'signs/history of heave or subsidence in the property/surrounding area';

    if (questionData.value.propertyLandslipHeave) {
      return `<span class="notice">There are</span> ${msg}`;
    }

    return `There are <span class="notice">no</span> ${msg}`;
  });
  const underPinning = computed(() => {
    if (helpers.isNull(questionData.value.propertyUnderpinning)) {
      return 'Please, select a value';
    }

    if (questionData.value.propertyUnderpinning) {
      return 'The property <span class="notice">has</span> been underpinned or <span class="notice">has had</span> structural support';
    }

    return 'The property <span class="notice">has not</span> been underpinned and <span class="notice">has never</span> had structural support';
  });
  const flooding = computed(() => {
    if (helpers.isNull(questionData.value.propertyFlooding)) {
      return 'Please, select a value';
    }

    const msg = questionData.value.propertyFlooding ? 'does have' : 'does not have';

    return `The property/area <span class="notice">${msg}</span> a history of flooding`;
  });
  const work = computed(() => {
    if (helpers.isNull(questionData.value.propertyWork)) {
      return 'Please, select a value';
    }

    const msg = questionData.value.propertyWork ? '<span class="notice">has</span>'
      : '<span class="notice">does not have</span> any';

    return `The property ${msg} building work in progress`;
  });
  const nearestRiver = computed(() => {
    if (helpers.isNull(questionData.value.propertyNearestRiver)) {
      return 'Please, select a value';
    }

    return `The nearest river/watercourse is <span class="notice">${lowerCase(getTextByValue(propertyNearestRiverItems.value, questionData.value.propertyNearestRiver))} </span>`;
  });
  const listed = computed(() => {
    if (helpers.isNull(questionData.value.propertyListed)) {
      return 'Please, select a value';
    }

    if (questionData.value.propertyListed === 'N') {
      return 'The property <span class="notice">is not</span> a listed building';
    }

    const msg = questionData.value.propertyListed === 'P' ? "The property's listed status is" : 'The property is a';

    return `${msg} <span class="notice">${getTextByValue(propertyListedItems.value, questionData.value.propertyListed)}</span>`;
  });
  const mainResidence = computed(() => {
    if (helpers.isNull(questionData.value.propertyMainResidence)) {
      return 'Please, select a value';
    }

    if (questionData.value.propertyMainResidence === 'Y') {
      return 'The property <span class="notice">is</span> your main residence';
    }

    const msg = questionData.value.propertyMainResidence === 'W' ? 'weekend home' : 'holiday home';

    return `The property is a <span class="notice">${msg}</span>`;
  });
  const stateOfRepair = computed(() => {
    if (helpers.isNull(questionData.value.propertyStateOfRepair)) {
      return 'Please, select a value';
    }

    const msg = questionData.value.propertyStateOfRepair ? 'is' : 'is not';

    return `The property <span class="notice">${msg}</span> in a good state of repair`;
  });
  const nearestTree = computed(() => {
    if (helpers.isNull(questionData.value.propertyNearestTree)) {
      return 'Please, select a value';
    }

    const msg = questionData.value.propertyNearestTree
      ? 'There <span class="notice">are</span>'
      : 'There are <span class="notice">no</span>';

    return `${msg} trees taller than 10 meters within 5 meters of your property`;
  });

  return {
    wallsMade,
    landslipHeave,
    underPinning,
    flooding,
    work,
    nearestRiver,
    listed,
    mainResidence,
    stateOfRepair,
    nearestTree,
  };
};
